import {
  Button,
  ButtonGroup,
  DatePicker,
  Group,
  IconDocument,
  IconHelp,
  IconWarningAlt,
  Modal,
  Select,
  Table,
  TextBox,
} from "@veneer/core";
import { useViewJustifications } from "../../hooks/justificationAbsences/useViewJustifications";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { IPropsComponentesTab } from "../../models/dto/justificationAbsences/IJustificationAbsenceModelDto";
import SimpleMessageModalWithOpenClose from "../Modals/SimpleMessageModalWithOpenClose";
import { Pie } from "react-chartjs-2";

export default function TabViewJustifications(props: IPropsComponentesTab) {
  const [t] = useTranslation("global");
  const {
    openModalHelp,
    setOpenModalHelp,
    handleOnDateRangeChange,
    dateOutsideRange,
    onClickConsultInformation,
    startDate,
    endDate,
    paginationProps,
    pagedData,
    columns,
    tablePreferences,
    modalUpdateOpen,
    setModalUpdateOpen,
    formValuesUpdate,
    optionsJustificationAbsence,
    onChangeJustificationAbsenceUpdate,
    handlerSubmitUpdate,
    openDeleteModal,
    setDeleteModal,
    handleDeleteJustificationAbsence,
    chartData,
    chartOptions,
    disabledBtnDownloadReport,
    getReportExcel
  } = useViewJustifications(props);

  return (
    <>
      <div className="justification-absences-buttons">
        <div className="justification-absences-buttons-left">
          <DatePicker
            range
            id="date-range-view"
            format="ll"
            onChange={handleOnDateRangeChange}
            startDate={startDate?.format('MM/DD/YYYY')}
            endDate={endDate?.format('MM/DD/YYYY')}
            startDatePlaceholder="MM/DD/YYYY"
            endDatePlaceholder="MM/DD/YYYY"
            startDateLabel={t("header.stardDate")}
            endDateLabel={t("header.endDate")}
            isOutsideRange={dateOutsideRange}
          />

          <Button
            style={{ margin: "10px" }}
            disabled={!(startDate && endDate)}
            onClick={onClickConsultInformation}
          >
            {t("header.consultInformation")}
          </Button>
        </div>

        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <div className="justification-absences-buttons-right">  
            <div className="tooltip">
              <span className="tooltiptext">
                {t("modal.titleHelper").replace(":", "")}
              </span>
              <Button
                style={{ margin: "5px" }}
                appearance="secondary"
                leadingIcon={<IconHelp />}
                onClick={() => setOpenModalHelp(true)}
              >
                {t("modal.titleHelper").replace(":", "")}
              </Button>
            </div>

            <div className="tooltip tooltip-attendance">
              <span className="tooltiptext">{t("header.download")}</span>
              <Button
                style={{ margin: "5px" }}
                appearance="primary"
                leadingIcon={<IconDocument />}
                disabled={disabledBtnDownloadReport}
                onClick={getReportExcel}
              >{t("header.download")}</Button>
            </div>
          </div>

          <div
            style={{
              minWidth: "350px",
              maxWidth: "100%",
              height: "150px",
            }}
          >
            <Pie data={chartData} options={chartOptions} />
          </div>
        </div>
      </div>

      <Table
        className="justificationAbsencesTable"
        behavior={{
          type: "singlePage",
        }}
        columnResize
        pagination={paginationProps}
        preferences={tablePreferences}
        showFilters={true}
        loading={props.loading}
        columns={columns}
        data={pagedData}
        loadingDataLength={10}
        customNoItems={
          <div className="customNoItems">
            <div className="DivIconCustomNoItems">
              <IconWarningAlt className="IconCustomNoItems" />
            </div>
            {t("header.noItemsFound")}
          </div>
        }
      />

      <div style={{ position: "relative" }}>
        <SimpleMessageModalWithOpenClose
          modalMessage={t("modal.descriptionModalHelpViewJustificationAbsences")}
          modalTitle={t("modal.titleHelper")}
          setOpenCloseModal={setOpenModalHelp}
          showModal={openModalHelp}
        />
      </div>

      {/* Modal Update */}
      <Modal
        align="start"
        id="modalUpdate"
        show={modalUpdateOpen}
        onClose={() => setModalUpdateOpen(false)}
        footer={
          <ButtonGroup>
            <Button onClick={handlerSubmitUpdate}>{t("header.update")}</Button>
            <Button
              appearance="secondary"
              onClick={() => setModalUpdateOpen(false)}
            >
              {t("header.cancel")}
            </Button>
          </ButtonGroup>
        }
        title={t("header.registerInformation")}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TextBox
              id="advisor-update"
              label={t("header.name")}
              placeholder={t("header.name")}
              disabled={true}
              value={formValuesUpdate.advisor}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextBox
              id="pos-code-update"
              label={t("header.pointOfSaleCode")}
              placeholder={t("header.pointOfSaleCode")}
              disabled={true}
              value={formValuesUpdate.posCode}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextBox
              id="pos-code-update"
              label={t("header.visitDate")}
              placeholder={t("header.visitDate")}
              disabled={true}
              value={formValuesUpdate.scheduledAppointmentDate}
            />
          </Grid>
          <Grid item xs={12} md={12}>
            <Select
              clearIcon={false}
              options={optionsJustificationAbsence}
              id="select-justification-absence-update"
              label={t("header.justificationAbsence")}
              placement="bottom"
              helperTextVisibility="auto"
              onChange={onChangeJustificationAbsenceUpdate}
              value={formValuesUpdate.justificationAbsenceType}
              required={true}
            />
          </Grid>
        </Grid>
      </Modal>

      {/* Modal Delete Justification Absence Question*/}
      <Modal
        align="start"
        id="modal-id"
        show={openDeleteModal}
        onClose={() => setDeleteModal(false)}
        footer={
          <Group>
            <Button onClick={handleDeleteJustificationAbsence}>
              {t("header.yes")}
            </Button>
            <Button
              appearance="secondary"
              onClick={() => setDeleteModal(false)}
            >
              No
            </Button>
          </Group>
        }
        title={t("modal.warningTitle")}
      >
        <p>{t("modal.questionDeleteAbsence")}</p>
      </Modal>
    </>
  );
}
